// 카카오 앱 키
const KAKAO_APP_KEY = 'e9cc8156973218f6b00b460a3758c905';

// 카카오 로그인 (OAuth 2.0 Authorization Code Flow)
export const kakaoLogin = async (): Promise<void> => {
  console.log('카카오 로그인 페이지로 리다이렉트');
  
  const redirectUri = `${window.location.origin}/kakao/callback`;
    
  // 카카오 로그인 페이지로 리다이렉트 (기본 scope만 사용)
  window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_APP_KEY}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=profile_nickname,profile_image,account_email`;
};